(function () {
  'use strict';

  angular
      .module('tf.retailer', [
        'ngAnimate',
        'tfc.sso',
        'tf.retailer.Api',
        'tf.retailer.Util',
        'tf.retailer.i18n',
        'tf.retailer.Analytics',
        'tfc.retailer.Brand',
        'tfc.retailer.Consumer',
        'tfc.retailer.FitConsistency',
        'tfc.retailer.Returns',
        'tfc.retailer.Purchase',
        'tfc.Reports',
        'tfc.News',
        'tfc.Help',
        'tfc.Terms',
        'tfc.Files',
        'tfc.Products',
        'ui.bootstrap',
        'ui.grid',
        'ui.grid.infiniteScroll',
        'tfc.retailer.DashboardDescription',
        'tfc.retailer.BrandSelection',
        'tfc.retailer.CollapsibleBox',
        'tfc.retailer.CategorySelection',
        'tfc.retailer.CollapsibleMenu',
        'tfc.retailer.ProductDetail',
        'tfc.retailer.ActivityRegionFilter',
        'tfc.retailer.Filter',
        'tfc.retailer.Pagination',
        'tfc.Toast',
        'tfc.retailer.AggregationDetail',
        'tfc.retailer.ConsumerSampling',
        'tfc.retailer.UIGrid',
        'tfc.retailer.StandardReports',
        'tfc.retailer.StoreSelection'
      ])
      .config(config)
      .run(run)
      .constant("ExcelReportType","application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
      .constant('Enums',{
        'TransactionFilterType' : {
          'Direct' : 'direct',
          'Wholesale': 'wholesale'
        }
      });

  // @ngInject
  function config($urlRouterProvider, $httpProvider, $uiViewScrollProvider, $provide, NavProvider, AuthProvider, ReportCategories, $uibModalProvider, BrandReportKeys, ConsumerReportKeys, LookAndFeelType) {

    AuthProvider.setBasePath('/retailer/ui');

    $httpProvider.interceptors.push('ApiErrorHandler');

    $uiViewScrollProvider.useAnchorScroll();

    $urlRouterProvider.otherwise(function ($injector) {
      var $state = $injector.get('$state');
      $state.go('login');
    });

    var canAccess = function (stateName, lookAndFeel) {
      // @ngInject
      function canAccessOverride($injector) {
        var $state = $injector.get('$state');
        var LookAndFeel = $injector.get('LookAndFeel');
        return $state.can(stateName) && _.eq(LookAndFeel.get(), lookAndFeel);
      }
      return canAccessOverride;
    };

    var brandMetricsMenuItems = [
      {
        state : 'news',
        translate : 'app.menu.news',
        iconCls : 'fa fa-newspaper-o fa-fw fa-lg',
        isBrandMetric: false,
        openAccess: false
      },
      {
        translate : 'app.menu.consumerDashboard',
        iconCls : 'fa fa-area-chart fa-fw fa-lg',
        isBrandMetric: true,
        children : []
            .concat(_.map(ConsumerReportKeys, function (report) {
              return { state : 'consumerReports.' + report, translate : 'app.menu.consumerReports.' + report }
            }))
            .concat(_.map(BrandReportKeys, function (report) {
              return { state : 'brandReports.' + report, translate : 'app.menu.brandReports.' + report }
            }))
            .concat({state : 'purchase.attributes', translate : 'app.menu.purchaseAttributes'})
            .concat({state : 'consumer.sampling', translate : 'app.menu.consumerSampling'})
      },
      {
        translate : 'app.menu.product',
        iconCls : 'fa fa-level-down fa-rotate-90 fa-fw fa-lg',
        isBrandMetric: true,
        children : [
          {
            state: 'returns.Performance',
            translate: 'app.menu.returns.performance'
          },
          {
            state: 'returns.PerformanceBySize',
            translate: 'app.menu.returns.performanceBySize'
          },
          {
            state : 'fitConsistency.Consistency',
            translate : 'app.menu.consistency'
          }
        ]
      },
      {
        state: 'analytics',
        translate : 'app.menu.analytics',
        iconCls : 'fa fa-pie-chart fa-fw fa-lg',
        isBrandMetric: true
      },
      {
        state : 'help',
        translate : 'app.menu.help',
        iconCls : 'fa fa-question-circle fa-fw fa-lg',
        isBrandMetric: false,
        openAccess: true
      }
    ];

    var analyticsMenuItems = [
      {
        translate : 'app.menu.executive.summary',
        children : [
          {
            state: 'executiveSummary.summary',
            translate: 'app.menu.executiveSummary.summary'
          }
        ]
      },
      {
        translate : 'app.menu.shoppers',
        children : [
          {
            state: 'shoppers.summary',
            translate: 'app.menu.shoppers.summary'
          },
          {
            state: 'shoppers.sessions',
            translate: 'app.menu.shoppers.sessions'
          },
          {
            state: 'shoppers.activeUsers',
            translate: 'app.menu.shoppers.active.users'
          },
          {
            state: 'shoppers.adoption',
            translate: 'app.menu.shoppers.adoption'
          },
          {
            state: 'shoppers.kids',
            translate: 'app.menu.shoppers.kids'
          },
          {
            state: 'shoppers.sfo',
            translate: 'app.menu.shoppers.sfo'
          },
          {
            state: 'shoppers.shopperProfiles',
            translate: 'app.menu.shoppers.profiles'
          }
        ]
      },
      {
        translate : 'app.menu.transactions',
        children : [
          {
            state: 'transactions.summary',
            translate: 'app.menu.transactions.summary'
          },
          {
            state: 'transactions.orders',
            translate: 'app.menu.transactions.orders'
          },
          {
            state: 'transactions.revenue',
            translate: 'app.menu.transactions.revenue'
          },
          {
            state: 'transactions.ordersRate',
            translate: 'app.menu.transactions.orders.rate'
          }
        ]
      },
      {
        translate : 'app.menu.comparisons',
        children : [
          {
            state: 'comparisons.dateRange',
            translate: 'app.menu.comparisons.date.range'
          },
          {
            state: 'comparisons.hierarchy',
            translate: 'app.menu.comparisons.hierarchy'
          }
        ]
      },
    ];

    var menuItemsMap = [
      {
        lookAndFeelType: LookAndFeelType.BrandMetrics,
        items: brandMetricsMenuItems
      },
      {
        lookAndFeelType: LookAndFeelType.Analytics,
        items: analyticsMenuItems
      }
    ];

    function overrideCanAccess(menuItems, lookAndFeel) {
      return _.map(menuItems, function (item) {
        if(item.state) {
          item.canAccess = canAccess(item.state, lookAndFeel);
        }
        if(item.children) {
          _.each(item.children, function (child) {
            if(_.isString(child.state)) {
              child.canAccess = canAccess(child.state, lookAndFeel)
            }
            else if(child.state && child.state.name){
              child.canAccess = canAccess(child.state.name, lookAndFeel)
            }
          })
        }
        return item;
      });
    }

    var menuItems = _.flatMap(menuItemsMap, function (menuItem) {
      return overrideCanAccess(menuItem.items, menuItem.lookAndFeelType);
    });

    NavProvider
        .setAppTitle({
          translate : 'app.menu.title'
        });

    _.each(menuItems, function (menuItem) {
      NavProvider.addMain(menuItem);
    });

    // Always use custom modal window template
    _.extend($uibModalProvider.options, {
      // can't hide their backdrop with javascript because the function called
      // when clicking the backdrop (close) exits if backdrop is false.
      //backdrop : false,
      windowTemplateUrl : 'Util/Modal.tmpl.html'
    });

    $provide.decorator('$state', function ($delegate, $injector) {
      var originalCan = $delegate.can;
      $delegate.termCan = function (stateName) {
        var state = $delegate.get(stateName);
        var Terms = $injector.get('Terms');
        return !(state.data && state.data.requireTerms) || Terms.cookieExistsAndAccepted();
      };

      $delegate.can = function (stateName) {
        return originalCan(stateName) && $delegate.termCan(stateName);
      };

      return $delegate;
    });
  }

  // @ngInject
  function run($rootScope, $state, $injector, Nav, GaUtil, Auth, CookieJar, Terms,BrandReports,$stateParams, Toast,
               translateFilter, $log, ApiErrorHandler, LookAndFeel, UtilCacheProvider, AnalyticsHelper) {
    GaUtil.createGaTracker();
    $rootScope.isLoading = true;

    // TODO Temporary handling for existing invalid cookies. Safe to remove in future
    var selectedBrand = CookieJar.get('tfc-insight-selected-brand');
    if(selectedBrand && selectedBrand.includes(' ')) {
      CookieJar.set({name : 'tfc-insight-selected-brand',value : encodeURIComponent(selectedBrand)});
    }

    $rootScope.$on('auth.login', function () {
      var user = Auth.getUser();

      LookAndFeel.setLookAndFeelOnUserLogin(user);

      AnalyticsHelper.sendLoginEvent();

      $rootScope.isLoading = false;

      Terms.isAccepted()
          .then(function(isAccepted){
            if(isAccepted){
              $rootScope.isLoading = true;
              invokeFirstItem(user);
            } else{
              $rootScope.isLoading = true;
              $state.go('terms');
            }
          });
    });

    $rootScope.$on('auth.logout', function () {
      LookAndFeel.reset();
      CookieJar.remove('tfc-insight-selected-brand');
    });

    $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState){
      var isAuthenticated = Auth.isAuthenticated();
      if(isAuthenticated) {

        if (Terms.getCookie() && !$state.termCan(toState.name)) {
          event.preventDefault();
          $state.go('terms');
        } else {
          Terms.isAccepted().then(function(isAccepted){
            if(!isAccepted){
              event.preventDefault();
              $state.go('terms');
            }
          });
        }
      }

      if(isAuthenticated){
        AnalyticsHelper.sendPageChangeEvent(fromState, toState);
      }

    });

    $rootScope.$watch(Auth.isAuthenticated, function() {
      UtilCacheProvider.removeAll();
      var user = Auth.getUser();
      if (user) {
        AnalyticsHelper.setUserIdDimension();
      }
    });

    $rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
      $log.error(error);
      var status = ApiErrorHandler.toastError(error);

      // If on transition to desired state fails and 'fromState' is empty then go to 'help'
      if(status && !fromState.name) {
        $state.go('help');
      }
    });


    function invokeFirstItem() {
      $rootScope.isLoading = true;

      var firstItem = _.find(Nav.mainMenu(), function (menuItem) {
        return $injector.invoke(menuItem.canAccess);
      });
      $injector.invoke(firstItem.onClick);

    }
  }

})();